<ng-template>
    <div class="wizard-status">
        <svg-icon key="check-circle" fontSize="6rem"></svg-icon>
        <h1>{{ title }}</h1>
        <p>{{ subtitle }}</p>
    </div>
</ng-template>